import React from 'react';

type Props = React.SVGAttributes<SVGSVGElement>;

export const PaintBrushIcon: React.FC<Props> = (props) => (
  <svg width="20" height="18" viewBox="0 0 20 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.621 9.26701C7.254 9.67101 7.164 9.96101 6.683 10.721C6.994 10.938 7.591 11.439 8.005 12.302C8.832 11.827 9.218 11.755 9.656 11.386C12.518 8.97601 19.526 0.337005 19.285 0.0870054C19.032 -0.177995 10.141 6.50301 7.621 9.26701ZM5.857 11.392C4.614 11.172 3.387 11.958 2.568 13.922C1.748 15.886 0.284 16.672 0 16.624C1.528 17.177 6.188 18.591 7.346 13.208C6.854 11.917 5.857 11.392 5.857 11.392Z" />
  </svg>
);
